import { LuLayoutDashboard } from 'react-icons/lu'
import {
    FaHouseDamage,
    FaList,
    FaProjectDiagram,
    FaRegBuilding,
    FaUserCog,
    FaUsers,
    FaUsersCog,
    FaUserSecret,
} from 'react-icons/fa'
import { RiFolderSettingsFill, RiListSettingsLine, RiSettings4Line } from 'react-icons/ri'
import { MdFeedback, MdOutlineElectricMeter } from 'react-icons/md'
import { TbReport } from 'react-icons/tb'

const appRoutes = [
    {
        text: 'Menu',
        child: [
            {
                url: '/admin',
                text: 'Dashboard',
                icon: <LuLayoutDashboard />,
            },
            {
                active: ['/admin/admins'],
                url: '/admin/admins',
                text: 'Admins',
                icon: <FaUserSecret />,
            },
            {
                active: ['/admin/roles'],
                url: '/admin/roles',
                text: 'Roles',
                icon: <FaUserCog />,
            },
            {
                active: ['/admin/users'],
                url: '/admin/users',
                text: 'Users',
                icon: <FaUsersCog />,
            },
            {
                active: ['/admin/customers'],
                url: '/admin/customers',
                text: 'Customers',
                icon: <FaRegBuilding />,
            },
            {
                active: ['/admin/inspectors'],
                url: '/admin/inspectors',
                text: 'Inspectors',
                icon: <FaUsers />,
            },
            {
                active: ['/admin/projects'],
                url: '/admin/projects',
                text: 'Projects',
                icon: <FaProjectDiagram />,
            },
            {
                active: ['/admin/transformers'],
                url: '/admin/transformers',
                text: 'Transformers',
                icon: <FaHouseDamage />,
            },
            {
                active: ['/admin/test-types'],
                url: '/admin/test-types',
                text: 'Test Data',
                icon: <RiListSettingsLine />,
            },
            {
                active: ['/admin/transformer-tests'],
                url: '/admin/transformer-tests',
                text: 'Test Groups',
                icon: <MdOutlineElectricMeter />,
            },
            {
                active: ['/admin/feedbacks'],
                url: '/admin/feedbacks',
                text: 'Feedbacks',
                icon: <MdFeedback />,
            },
            {
                active: [
                    '/admin/reports/customer-satisfaction',
                    '/admin/reports/monthly-customer-satisfaction',
                    '/admin/reports/customer-comments',
                ],
                text: 'Reports',
                icon: <TbReport />,
                child: [
                    {
                        active: ['/admin/reports/customer-satisfaction'],
                        url: '/admin/reports/customer-satisfaction',
                        text: 'Customer Satisfaction',
                    },
                    {
                        active: ['/admin/reports/monthly-customer-satisfaction'],
                        url: '/admin/reports/monthly-customer-satisfaction',
                        text: 'Monthly Satisfaction',
                    },
                    {
                        active: ['/admin/reports/customer-comments'],
                        url: '/admin/reports/customer-comments',
                        text: 'Customer Comments',
                    },
                ],
            },
            {
                active: [
                    '/admin/cooling-types',
                    '/admin/reference-standards',
                    '/admin/winding-materials',
                    '/admin/equipments',
                    '/admin/diagrams',
                    '/admin/lab-surface-areas',
                ],
                text: 'Master',
                icon: <RiFolderSettingsFill />,
                child: [
                    {
                        active: ['/admin/cooling-types'],
                        url: '/admin/cooling-types',
                        text: 'Cooling Types',
                    },
                    {
                        active: ['/admin/reference-standards'],
                        url: '/admin/reference-standards',
                        text: 'Reference Standards',
                    },
                    {
                        active: ['/admin/winding-materials'],
                        url: '/admin/winding-materials',
                        text: 'Winding Materials',
                    },
                    {
                        active: ['/admin/equipments'],
                        url: '/admin/equipments',
                        text: 'Equipments',
                    },
                    {
                        active: ['/admin/diagrams'],
                        url: '/admin/diagrams',
                        text: 'Diagrams',
                    },
                    {
                        active: ['/admin/lab-surface-areas'],
                        url: '/admin/lab-surface-areas',
                        text: 'Lab Surface Areas',
                    },
                ],
            },
            {
                active: ['/admin/login-history'],
                url: '/admin/login-history',
                text: 'Login History',
                icon: <FaList />,
            },
            {
                active: ['/admin/setting'],
                url: '/admin/setting',
                text: 'Setting',
                icon: <RiSettings4Line />,
            },
        ],
    },
]

export default appRoutes
